import { render, staticRenderFns } from "./component.vue?vue&type=template&id=1beafd26&"
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"
import style0 from "./component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\progect\\guowai\\ex_express_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1beafd26')) {
      api.createRecord('1beafd26', component.options)
    } else {
      api.reload('1beafd26', component.options)
    }
    module.hot.accept("./component.vue?vue&type=template&id=1beafd26&", function () {
      api.rerender('1beafd26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/d2-video-uploader/component.vue"
export default component.exports